export const WORK_TYPE_CREATE_REQUESTED = 'WORK_TYPE_CREATE_REQUESTED';
export const WORK_TYPE_CREATE_SUCCEEDED = 'WORK_TYPE_CREATE_SUCCEEDED';
export const WORK_TYPE_CREATE_FAILED = 'WORK_TYPE_CREATE_FAILED';

export const WORK_TYPE_DELETE_REQUESTED = 'WORK_TYPE_DELETE_REQUESTED';
export const WORK_TYPE_DELETE_SUCCEEDED = 'WORK_TYPE_DELETE_SUCCEEDED';
export const WORK_TYPE_DELETE_FAILED = 'WORK_TYPE_DELETE_FAILED';

export const WORK_TYPES_SET = 'WORK_TYPES_SET';
export const WORK_TYPE_SET = 'WORK_TYPE_SET';
